import { h } from "preact";
import { useEffect, useState } from "preact/hooks";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";

import AppFooter from "../components/AppFooter.jsx";
import AppHeader from "../components/AppHeader.jsx";
import AppLayout from "../components/AppLayout.jsx";
import AvatarAndUserInfo from "../components/AvatarAndUserInfo.jsx";
import ChangePasswordForm from "../components/ChangePasswordForm.jsx";
import CompanyLayout from "../components/companies/Layout.jsx";
import ProfileDeletionForm from "../components/ProfileDeletionForm.jsx";

import { renderHtml } from "../helpers.js";
import i18n from "../i18n.js";
import { selectCompany, selectCurrentUser } from "../store/index";
import profileApi from "../api/profile";
import Alert from "../components/Alert.jsx";
import NotificationsTab from "../components/settingsPage/NotificationsTab.jsx";

export default function ProfilePage() {
  const { subPage } = useParams();
  const [tabIndex, setTabIndex] = useState(0);
  const user = useSelector(selectCurrentUser);
  const company = useSelector(selectCompany);
  const navigate = useNavigate();

  const [data, setData] = useState(user);
  const [error, setError] = useState(null);

  useEffect(async () => {
    try {
      const result = await profileApi.me();
      setData(result);
    } catch (err) {
      setError(
        (err.response && err.response.error) ||
          err.message ||
          i18n.t("errors.profile_details_load_error")
      );
    }
  }, []);

  useEffect(async () => {
    switch (subPage) {
      case "account":
        setTabIndex(1);
        break;
      case "notifications":
        setTabIndex(2);
        break;
    }
  }, []);
  function onSelect(index) {
    setTabIndex(index);
    navigate(
      `/settings/${
        index === 0 ? "" : index === 1 ? "account" : "notifications"
      }`
    );
  }

  if (!user) {
    window.location.href = "/login";
    return;
  }

  const Layout = company ? CompanyLayout : AppLayout;

  return (
    <Layout
      header={<AppHeader title={i18n.t("pages.titles.settings")} />}
      footer={<AppFooter />}
    >
      {error ? (
        <Alert class="mb-16" error>
          {error}
        </Alert>
      ) : (
        <div>
          <AvatarAndUserInfo
            bordered
            class="mb-48"
            user={data}
            company={company}
          />

          <Tabs selectedIndex={tabIndex} onSelect={(index) => onSelect(index)}>
            <div class="secondary-navi__wrapper">
              <TabList className="secondary-navi mb-48">
                <Tab
                  className="secondary-navi__item waves-effect waves-light"
                  selectedClassName="secondary-navi__item--active"
                >
                  {i18n.t("pages.settings.security.title")}
                </Tab>
                <Tab
                  className="secondary-navi__item waves-effect waves-light"
                  selectedClassName="secondary-navi__item--active"
                >
                  {i18n.t("pages.settings.account.title")}
                </Tab>
                <Tab
                  className="secondary-navi__item waves-effect waves-light"
                  selectedClassName="secondary-navi__item--active"
                >
                  {i18n.t("pages.settings.notifications.title")}
                </Tab>
              </TabList>
            </div>
            <TabPanel>
              <section>
                <div class="row">
                  <div class="col s12 l7 ml-0">
                    <h2 class="t-h6 t-h6--margin">
                      {i18n.t("pages.settings.security.title")}
                    </h2>
                    <h3 class="t-subtitle1 t-subtitle1--margin mb-32">
                      {i18n.t("pages.settings.security.subtitle")}
                    </h3>
                  </div>
                  <div class="col s12 l6 ml-0">
                    <ChangePasswordForm />
                  </div>
                </div>
              </section>
            </TabPanel>
            <TabPanel>
              <section>
                <div class="row">
                  <div class="col s12 l7 ml-0">
                    <h2 class="t-h6 t-h6--margin">
                      {i18n.t("pages.settings.account.title")}
                    </h2>
                    <h3 class="t-subtitle1 t-subtitle1--margin-small">
                      {i18n.t("pages.settings.account.subtitle")}
                    </h3>
                    <p class="t-body2 t-body3--mobile">
                      {renderHtml(i18n.t("pages.settings.account.paragraph1"))}
                    </p>
                    <p class="t-body2 t-body3--mobile mb-48">
                      {i18n.t("pages.settings.account.paragraph2")}
                    </p>
                  </div>
                  <div class="col s12 l6 ml-0">
                    <ProfileDeletionForm />
                  </div>
                </div>{" "}
              </section>
            </TabPanel>
            <TabPanel>
              <NotificationsTab />
            </TabPanel>
          </Tabs>
        </div>
      )}
    </Layout>
  );
}
